import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/utils";

const buttonVariants = cva("ui-button", {
    variants: {
        variant: {
            default: "ui-button--default",
            outline: "ui-button--outline",
            ghost: "ui-button--ghost"
        },
        size: {
            default: "ui-button--size-default",
            sm: "ui-button--size-sm",
            icon: "ui-button--size-icon"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});

export interface ButtonProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {
    asChild?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
    ({ className, variant, size, asChild = false, ...props }, ref) => {
        const Comp = asChild ? Slot : "button";
        return <Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />;
    }
);
Button.displayName = "Button";

export { Button, buttonVariants };
